import {StandardPageSize} from "@react-pdf/types";
import {Orientation} from "@react-pdf/types/page";

import {
  FormLabelBannerEnum,
  FormLabelDiscountDetailEnum,
  FormLabelMechanicalEnum,
  FormLabelMechanicalGroupEnum,
  FormLabelType
} from "../Types";
import {FormPaperColorEnum, FormPrintColorEnum, FormPrintOptionsType} from "../../../Types";

import preview from "../preview.jpg"
import {getDefaultTitleValue} from "./mechanical";

export const getPreview = () => {
  return preview
}

export const getDefaultPrintOptions = (): FormPrintOptionsType => {
  return {
    size: 'A4',
    orientation: 'portrait',
    printColor: FormPrintColorEnum.COLOR,
    paperColor: FormPaperColorEnum.YELLOW,
  };
}

export const getDefaultLabel = (size: StandardPageSize, orientation: Orientation): Omit<FormLabelType, 'id'> => {
  return {
    mechanicalGroup: FormLabelMechanicalGroupEnum.BRI,
    mechanical: FormLabelMechanicalEnum.BRI_AMOUNT,
    title: getDefaultTitleValue(FormLabelMechanicalEnum.BRI_AMOUNT),
    banner: FormLabelBannerEnum.PRICE_DECREASE,
    ean: "",
    name: "COTOPHARM",
    capacity: "180 cotons bio",
    discount: "3",
    discountPrecision: "",
    discountDetail: FormLabelDiscountDetailEnum.LIMIT,
    discountLimit: [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    ],
    price: "9.99",
    oldPrice: "12.99",
    icon: "Euro",
  };
}
